const targetText = 'Other Vehicle Types';

const element = document.evaluate(
`//a[contains(text(), '${targetText}')]`,
document,
null,
XPathResult.FIRST_ORDERED_NODE_TYPE,
null
).singleNodeValue;



const newelement=element.parentNode.parentNode;


const clonedElement = newelement.cloneNode(true);


clonedElement.classList.remove('no-mega-menu', 'item','menu-lv-1');


clonedElement.classList.add('menu-lv-2','kj');


const targetText2 = 'Shop By Vehicle';



const element2 = document.evaluate(
`//a[contains(text(), '${targetText2}')]`,
document,
null,
XPathResult.FIRST_ORDERED_NODE_TYPE,
null
).singleNodeValue;


const newelement2=element2.parentNode.parentNode;


newelement2.classList.add('kk');

const menutoputin=document.querySelector(".kk > div > div.site-nav-dropdown.style_3 > div > div > ul")



menutoputin.appendChild(clonedElement);


newelement.style.display='none';

const menuUlElement=document.querySelector("ul.site-nav li.kj ul.site-nav-dropdown")

const ulLiCount=menuUlElement.childElementCount
menuUlElement.style.display='flex';
menuUlElement.style.flexDirection= 'row';
menuUlElement.style.justifyContent= 'space-around';

document.querySelector(".site-nav li.kj > p").style.position = "relative";
document.querySelector(".site-nav li.kj > p").style.textAlign = "justify";
